var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      {
        staticClass: "nav",
        style: { width: _vm.isCollapse ? "60px" : "210px" },
      },
      [
        _c(
          "div",
          { staticClass: "logo" },
          [
            _c("svg-icon", {
              staticStyle: {
                width: "210px",
                height: "40px",
                "margin-top": "5px",
              },
              attrs: { className: "icon", iconClass: "logo" },
            }),
          ],
          1
        ),
        _c("Nav", { ref: "nav", staticStyle: { height: "calc(100% - 55px)" } }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "main",
        style: {
          width: _vm.isCollapse ? "calc(100% - 60px)" : "calc(100% - 210px)",
        },
      },
      [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "alive-item" }, [_c("alive-nav")], 1),
          _c(
            "div",
            { staticClass: "page" },
            [_c("keep-alive", [_c("router-view")], 1)],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }